<template>
  <div class="Settings">
    
    <div class="modal" id="settings">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Ustawienia</p>
          
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
            <p>Wprowadź adresy email odzielane średnikami:</P>
            <div class="field">
                <div class="control">
                    <textarea class="textarea is-small" v-model="data" placeholder="np: login1@mail.pl; login2@mail.pl"></textarea>
                </div>
            </div>

          
        </section>
        <footer class="modal-card-foot">
          <button v-if="saving == false" @click="save" class="button is-small">Zapisz</button>
          <button v-else class="button is-loading is-small">Zapisz</button>
          <button @click="cancel" class="button  is-small">Cancel</button>
        </footer>
      </div>
    </div>
    
   
  </div>
</template>

<script>



export default {
  name: 'Settings',
  props: {
    //data: Object,
    
  },
  data() {
    return {
      data: "",
      saving: false
    }
  },
  computed: {
          
    role(){
      return this.$store.getters.role
    }
  },
  watch: {
    role: function(newData, oldData){
      
       this.$store.dispatch('getProps')
            .then(response => {
                
                this.data = response;
            })
            .catch(error => {
                console.log(error)
                return error
            });
    }
  },
  mounted () {
    this.$store.dispatch('getProps')
            .then(response => {
                
                this.data = response;
            })
            .catch(error => {
                console.log(error)
                return error
            });
    
  },
  updated() {
    console.log("updated")
  },
  methods: {
          save(){
            
            this.saving = true

            var objData = {
                data: this.data
                
            }
            this.$store.dispatch('setProps', objData)
            .then(response => {
                
                if (response){
                    this.saving = false
                    var set = document.getElementById("settings")
                    set.classList.remove("is-active");
                }
            })
            .catch(error => {
                console.log(error)
                return error
            });

            
          },
          cancel(){
            

            var set = document.getElementById("settings")
            set.classList.remove("is-active");
          }
        },
}
</script>

<style scoped>
  .Settings {
      
      
  }
  
</style>
